module.exports = __webpack_public_path__ + "static/media/autonomo.fe55647c.jpg";